export const config = [
  {
    icon: 'https://img.alicdn.com/tfs/TB1iTotCkT2gK0jSZFkXXcIQFXa-132-138.png',
    cover: 'https://img.alicdn.com/tfs/TB1jDcoClv0gK0jSZKbXXbK2FXa-600-778.png',
    title: '健康医疗数据中心',
    desc: '形成统一标准 数据汇聚共享<br/>云计算、高并发  数据安全协同提效',
    path: '/product?id=1',
  },
  {
    icon: 'https://img.alicdn.com/tfs/TB1kNwoCeT2gK0jSZFvXXXnFXXa-148-158.png',
    cover: 'https://img.alicdn.com/tfs/TB1LfQoChD1gK0jSZFsXXbldVXa-600-778.png',
    title: '智慧服务',
    desc: '统一健康门户 全流程就医<br/>AI算法模型 专业医学知识库',
    path: '/product?id=2',
  },
  {
    icon: 'https://img.alicdn.com/tfs/TB1Q4.rCi_1gK0jSZFqXXcpaXXa-138-150.png',
    cover: 'https://img.alicdn.com/tfs/TB1szksCbH1gK0jSZFwXXc7aXXa-600-778.png',
    title: '智慧临床',
    desc: '解决临床所需 提升工作效率<br/>人工智能助力 提高医疗质量',
    path: '/product?id=3',
  },
  {
    icon: 'https://img.alicdn.com/tfs/TB1EisqCeH2gK0jSZFEXXcqMpXa-142-140.png',
    cover: 'https://img.alicdn.com/tfs/TB1tI7qCkL0gK0jSZFAXXcA9pXa-600-778.png',
    title: '智慧管理',
    desc: '大数据挖掘分析 辅助管理提效<br/>借助数据生产力 减少决策成本',
    path: '/product?id=4',
  },
];
